import { render, staticRenderFns } from "./message-plugin-layout-web.vue?vue&type=template&id=2e62f7e8&scoped=true"
import script from "./message-plugin-layout-web.vue?vue&type=script&lang=ts"
export * from "./message-plugin-layout-web.vue?vue&type=script&lang=ts"
import style0 from "./message-plugin-layout-web.vue?vue&type=style&index=0&id=2e62f7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e62f7e8",
  null
  
)

export default component.exports